<template>
  <footer class="app-footer">
    <!-- Top Section: Subscribe & Social -->
    <div class="footer-top">
      <div class="content-wrapper top-content">
        <!-- Subscribe -->
        <div class="subscribe-box">
          <input type="email"
                 :placeholder="$t('footer.subscribe.placeholder')"
                 class="sub-input"
                 v-model="subscribeEmail"
                 @keyup.enter="submitSubscribe" />
          <button class="sub-btn"
                  @click="submitSubscribe"
                  :disabled="isSubscribing">{{ $t('footer.subscribe.button') }}</button>
        </div>
        <!-- Social Icons -->
        <div class="social-icons">
          <a :href="icon.href || '#'"
             v-for="(icon, index) in socialIcons"
             :key="index"
             class="social-link"
             target="_blank"
             rel="noopener noreferrer">
            <img :src="icon.src"
                 :alt="$t(`footer.social.${icon.key}`)"
                 class="social-icon" />
          </a>
        </div>
      </div>
    </div>

    <!-- Bottom Section: Links & Info -->
    <div class="footer-bottom">
      <div class="content-wrapper bottom-content">
        <!-- Left: Logo & Desc -->
        <div class="footer-left">
          <div class="logo-wrapper">
            <!-- 使用文本或图片Logo -->
            <div class="footer-logo-placeholder">
              <img src="@/assets/logo2.png"
                   alt="Logo"
                   class="logo-icon" />

            </div>
          </div>
          <p class="company-desc">
            {{ $t('footer.companyDesc') }}
          </p>
        </div>

        <!-- Center: Navigation Grid -->
        <div class="footer-center">
          <div class="nav-grid">
            <div v-for="(col, index) in navColumns"
                 :key="index"
                 class="nav-column">
              <h4 class="nav-title">{{ col.title }}</h4>
              <ul class="nav-list">
                <li v-for="(item, idx) in col.items"
                    :key="idx"
                    class="nav-item">
                  <router-link v-if="item.to"
                               :to="item.to">{{ item.label }}</router-link>
                  <a v-else
                     href="#">{{ item.label }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Right: Contact & QR -->
        <div class="footer-right">
          <div class="contact-list">
            <div class="contact-item">
              <span class="contact-icon"><img src="@/assets/footer/phone.png"
                     alt="Phone"
                     class="contact-icon-img" /></span>
              <span class="contact-text">{{ $t('footer.contact.phone') }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon"><img src="@/assets/footer/email.png"
                     alt="Email"
                     class="contact-icon-img" /></span>
              <span class="contact-text">{{ $t('footer.contact.email') }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon"><img src="@/assets/footer/local.png"
                     alt="Location"
                     class="contact-icon-img" /></span>
              <span class="contact-text">{{ $t('footer.contact.address') }}</span>
            </div>
          </div>
          <div class="qr-area">
            <div class="qr-wrapper">
              <!-- 使用示例二维码 -->
              <img src="@/assets/footer/code.png"
                   alt="QR Code"
                   class="qr-code" />
            </div>
            <span class="qr-desc">{{ $t('footer.qrDesc') }}</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { emailSubmitApi } from '@/api'

export default {
  name: 'AppFooter',
  data() {
    return {
      subscribeEmail: '',
      isSubscribing: false,
      socialIcons: [
        {
          key: 'tiktok',
          src: require('@/assets/footer/dy.png'),
          href: 'https://www.douyin.com/user/self?from_tab_name=main',
        },
        { key: 'weibo', src: require('@/assets/footer/video.png') },
        { key: 'wechat', src: require('@/assets/footer/weichat.png') },
        {
          key: 'redbook',
          src: require('@/assets/footer/redbook.png'),
          href: 'https://www.xiaohongshu.com/user/profile/5f55d9ab000000000101f640',
        }
      ],
    }
  },
  computed: {
    footerCopy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages = this.$i18n && this.$i18n.getLocaleMessage ? this.$i18n.getLocaleMessage(locale) : {}
      return messages.footer || {}
    },
    navColumns() {
      return this.footerCopy.navColumns || []
    }
  },
  methods: {
    async submitSubscribe() {
      if (this.isSubscribing) return

      const email = (this.subscribeEmail || '').trim()
      if (!email) {
        this.$message.warning(this.$t('globalContactForm.validation.email'))
        return
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(email)) {
        this.$message.warning(this.$t('globalContactForm.validation.emailFormat'))
        return
      }

      try {
        this.isSubscribing = true
        const result = await emailSubmitApi.submitEmail(email)
        const ok =
          result &&
          (result.code === 200 || result.success === true || result.ok === true)

        if (!ok) {
          this.$message.error(
            (result && (result.message || result.msg)) || this.$t('globalContactForm.error')
          )
          return
        }

        this.$message.success(this.$t('globalContactForm.success'))
        this.subscribeEmail = ''
      } catch (e) {
        this.$message.error(this.$t('globalContactForm.networkError'))
      } finally {
        this.isSubscribing = false
      }
    }
  }
}
</script>

<style scoped>
.app-footer {
  width: 100%;
  background-color: #fff;
  font-family: sans-serif;
}

.content-wrapper {
  width: 1200px;
  margin: 0 auto;
}

/* Top Section */
.footer-top {
  height: 140px;
  border-bottom: 1px solid #e2e2e2;
  display: flex;
  align-items: center;
}

.top-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subscribe-box {
  display: flex;
  align-items: center;
}

.sub-input {
  width: 300px;
  height: 48px;
  padding: 0 20px;
  border: 1px solid #e2e2e2;
  border-radius: 12px; /* 独立圆角 */
  font-size: 14px;
  outline: none;
  color: #333;
  margin-right: 10px; /* 间距 */
}

.sub-input::placeholder {
  color: #999;
}

.sub-btn {
  height: 48px;
  padding: 0 30px;
  background-color: #fbbc05;
  border: none;
  border-radius: 12px; /* 独立圆角 */
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.sub-btn:hover {
  background-color: #e0a800;
}

.social-icons {
  display: flex;
  gap: 20px;
}

.social-link {
  display: block;
  width: 35px;
  height: 36px;
  transition: transform 0.3s;
}
.contact-icon-img {
  width: 16px;
  height: 16px;
}
.social-link:hover {
  transform: translateY(-2px);
}

.social-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Bottom Section */
.footer-bottom {
  padding: 60px 0 80px;
}

.bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* Left Part */
.footer-left {
  width: 300px;
  flex-shrink: 0;
}

.logo-wrapper {
  margin-bottom: 20px;
}

.footer-logo-placeholder {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-icon {
  width: 142px;
  height: 50px;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #003399; /* 假设品牌色 */
}

.company-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  text-align: justify;
}

/* Center Part */
.footer-center {
  flex: 1;
  margin: 0 60px;
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 40px;
  column-gap: 20px;
}

.nav-column {
  display: flex;
  flex-direction: column;
}

.nav-title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin: 0 0 20px 0;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 12px;
}

.nav-item a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.nav-item a:hover {
  color: #fbbc05;
}

/* Right Part */
.footer-right {
  width: 300px; /* 适当调整 */
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.contact-list {
  margin-bottom: 30px;
}

.contact-item {
  display: flex;
  align-items: flex-start; /* 对齐顶部 */
  margin-bottom: 12px;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.contact-icon {
  margin-right: 10px;
  font-style: normal;
}

.contact-text {
  flex: 1;
}

.qr-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-start; /* 靠左对齐或者居中，看设计图，通常是在右下角 */
  margin-left: 20px; /* 如果需要稍微右移 */
  margin-top: 115px; /* 如果需要稍微右移 */
}

.qr-wrapper {
  width: 120px;
  height: 120px;
  border: 1px solid #eee;
  padding: 5px;
  margin-bottom: 10px;
}

.qr-code {
  width: 100%;
  height: 100%;
}

.qr-desc {
  font-size: 14px;
  color: #333;
}
</style>
